import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InterruptableTimer } from 'src/app/model/interruptabletimer';

@Component({
  selector: 'app-distance-editor',
  templateUrl: './distance-editor.component.html',
  styleUrls: ['./distance-editor.component.scss']
})
export class DistanceEditorComponent implements OnInit {

  public metric = '1';
  private _length: number = 0;
  public set length(len: number) {
    if (len === this._length) return;
    this._length = len;
    this.HandleMetric();
  }
  public get length(): number {
    return this._length;
  }
  private timer = new InterruptableTimer(500);
  private _distance: number = 0;
  @Input()
  public distance: number = 0;
  @Output()
  public distanceChange = new EventEmitter<number>();

  @Input()
  set percent_length(len:number) {
    this._percent_length = len;
    this.metric = '%';
    this.HandleMetric();
  }
  private _percent_length: number = 0;
  get percent_length():number {
    return this._percent_length;
  }
  constructor() { }

  ngOnInit(): void {
    this.length = this.distance;
  }

  HandleMetric() {
    if(this.metric === '%' && this.percent_length===0) {
      this.metric = '1';
    }
    this.timer.Start(() => {
      if (this.metric === '%') {
        this.distance = this.percent_length * (this.length / 100.0);

      } else {
        this.distance = this.length * Number(this.metric);

      }
      this.distanceChange.emit(this.distance);
    });
  }
}
